import styled from 'styled-components';
import {dFlex,  justifyEnd} from '../../globalVariables/GlobalFlex';
import {icon} from '../classes/input';
import {checkbox} from '../checkbox/Checkbox.css';

export const content = styled.div`
    ${icon}{
        width: unset;
        height: unset;
    }
    height: calc(100% - 30px);
`;

export const inputGroup = styled.div`
    ${dFlex};
    gap: 10px;
    ${checkbox}{
        margin: unset;
    }
`;

export const label = styled.span``;

export const buttonGroup = styled.div`
    ${dFlex};
    ${justifyEnd};
    gap:10px;
    height:max-content;
`;

export const contentWrapper = styled.div`
     width: 100%;
    height: 250px;
    padding: 20px 20px 0 20px;
`;
